export const EXCEPTIONS_AND_OPPORTUNITY = "EXCEPTIONS_AND_OPPORTUNITY";
export const STOP_TYPE = "STOP_TYPE";
export const SCHEDULED_COLLECTIONS = "SCHEDULED_COLLECTIONS";
export const DRIVER_TYPE = "DRIVER_TYPE";
export const VEHICLE_TYPE = "VEHICLE_TYPE";
export const STOP_VOLUMES = "STOP_VOLUMES";
export const PLANNED_READY_TIME = "PLANNED_READY_TIME";
export const SECTION = "SECTION";
export const ROBOT_SUPPLIER = "ROBOT_SUPPLIER";
export const PICKUP_TYPE = "PICKUP_TYPE";
